module.exports = __webpack_public_path__ + "img/barnard_2.80e6513c.jpg";